import React, {useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import PaginatedTable from "../../../components/Block/Table/PaginatedTable";
import LoadSpinner from "../../../components/Common/LoadSpinner";
import {Check, Slash} from 'react-feather';
import {adminGetBrokerDetails} from "../../../services/api/admin";

function BrokerDetails() {
    const {id} = useParams();
    const [brokerData, setBrokerData] = useState(null);
    const headers = [
        {data: 'ID', classes: ""},
        {data: 'Name', classes: ""},
        {data: 'Slug', classes: ""},
        {data: 'Website', classes: ""},
        {data: 'Highlighted Vendor'}
    ]; // Table headers

    const getBroker = async () => {
        try {
            const data = await adminGetBrokerDetails(id);
            const transformedData = {
                id: {data: data.id},
                name: {data: data.name, classes: "sl-max-w-64"},
                slug: {data: data.slug, classes: "sl-max-w-64"},
                website: {data: data.website},
                superFlag: {data: data.superflag ? <Check/> : <Slash/>},
            };
            setBrokerData(transformedData);
        } catch (e) {
            console.error('Error fetching messages:', e);

        }
    }

    React.useEffect(() => {
            getBroker().then(r => console.log(r));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [id]);


    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8">
                    {brokerData ? (
                        <div>
                            <h1>Broker: {brokerData.name?.data}</h1>
                            <div className="sl-table-container">
                                <PaginatedTable
                                    headers={headers}
                                    data={[brokerData]}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="sl-self-center sl-mt-3 sl-mb-21">
                            <LoadSpinner/>
                        </div>
                    )}
                    <div>
                        <Link to="/admin/brokers">Go Back to Brokers</Link>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default BrokerDetails;
